import Fingerprint2 from "fingerprintjs2"

export default function () {

    const that = this;

    that.hashPromise = getHash();


    function getHash() {
        return new Promise(function(resolve, reject) {
            if (window.requestIdleCallback) {
                requestIdleCallback(function () {
                    Fingerprint2.get(function (components) {
                        resolve(componentsToHash(components));
                    })
                })
            } else {
                setTimeout(function () {
                    Fingerprint2.get(function (components) {
                        resolve(componentsToHash(components));
                    })
                }, 500)
            }
        });
    }


    function componentsToHash(components) {
        const values = components.map(component => component.value);
        return Fingerprint2.x64hash128(values.join(''), 31);
    }

}